import { render, staticRenderFns } from "./CustomizerAttributeSelector.vue?vue&type=template&id=2c3eb3de&scoped=true&"
import script from "./CustomizerAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./CustomizerAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomizerAttributeSelector.vue?vue&type=style&index=0&id=2c3eb3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3eb3de",
  null
  
)

export default component.exports